import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCow } from '@fortawesome/free-solid-svg-icons/faCow';
import type { IconProps } from '../../types';

export function CowIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Cow',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faCow}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
